import React from 'react';

import Header from 'components/Header';
import { useTranslation } from 'react-i18next';
import './NewSigningHeader.scss';

const NewSigningHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Header>
      <div className="new-signing-header">{t('select-a-player-you-would-like-to-swap-out-for-another-player')}</div>
    </Header>
  );
};

export default NewSigningHeader;
